const ACCESS_TOKEN_LIFETIME = Number(
  process.env.REACT_APP_ACCESS_TOKEN_LIFETIME || 5 * 60,
);

export const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL!,
  ACCESS_TOKEN_LIFETIME,
  TIME_TO_REFRESH_TOKEN: ACCESS_TOKEN_LIFETIME - 60,
  GIT_HASH: process.env.REACT_APP_GIT_HASH || 'dev',
  BUILD_DATE: process.env.REACT_APP_BUILD_DATE || '',
};
